<template lang="pug">
.loginAlertModalComponent
  .title {{ text }}
  .button
    ui-button(@click="onButtonClick") Войти или зарегистрироваться
</template>

<script>
import { inject } from 'vue'
export default {
  props: {
    text: {
      type: String,
      default: 'Сначала нужно авторизоваться!'
    }
  },
  setup () {
    const store = inject('store')

    const onButtonClick = () => {
      store.user.login()
    }

    return { onButtonClick }
  }
}
</script>

<style lang="sass" scoped>
.loginAlertModalComponent
  padding: 0 10*$u

  > .title
    @include font(h2)
    margin-bottom: 9*$u
    text-align: center
    max-width: 150*$u

  > .button
    margin: 0 auto
    width: fit-content
</style>
